import { Plus } from "lucide-react";

export const FAQ = {
  no: { title: "Spørsmål om priser", items: [
    { q: "Er prisene inkludert mva.?", a: "Ja. Alle priser i prislisten er oppgitt inkludert mva." },
    { q: "Hva avgjør den endelige prisen?", a: "Prisene er veiledende. Endelig pris avhenger av bilmodell, årsmodell og oppdrag – blant annet nøkkeltype, ECU/TCU, programmeringsmetode, lisenskostnader og arbeidstid." },
    { q: "Kan jeg få et tilbud basert på registreringsnummeret?", a: "Ja. Oppgi registreringsnummeret i kontaktskjemaet eller når du ringer oss, så sjekker vi bilen din og gir deg et pristilbud for akkurat ditt oppdrag." },
    { q: "Avtales tilleggsarbeid på forhånd?", a: "Ja. Eventuelle tillegg avtales alltid med deg på forhånd, før arbeidet utføres." },
  ] },
  en: { title: "Questions about prices", items: [
    { q: "Do the prices include VAT?", a: "Yes. All prices in the price list are stated including VAT." },
    { q: "What determines the final price?", a: "The prices are indicative. The final price depends on the car model, model year and job – including key type, ECU/TCU, programming method, licence costs and labour time." },
    { q: "Can I get a quote based on my registration number?", a: "Yes. Enter the registration number in the contact form or give it to us when you call, and we will check your car and give you a quote for your specific job." },
    { q: "Are extra jobs agreed in advance?", a: "Yes. Any extras are always agreed with you in advance, before the work is carried out." },
  ] },
};

export const faqSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ.no.items.map(({ q, a }) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
});

export const PriceFaq = ({ lang }) => {
  const f = FAQ[lang] ?? FAQ.no;
  return (
    <section className="mt-16" data-testid="price-faq">
      <h2 className="font-display text-2xl font-bold uppercase md:text-3xl">{f.title}</h2>
      <div className="mt-4 border-t border-white/20">
        {f.items.map(({ q, a }, i) => (
          <details key={q} className="group border-b border-white/10" data-testid={`price-faq-item-${i}`}>
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-base text-white transition-colors hover:text-zinc-200 sm:text-lg [&::-webkit-details-marker]:hidden" data-testid={`price-faq-question-${i}`}>
              {q}
              <Plus size={18} className="shrink-0 text-[var(--red)] transition-transform duration-200 group-open:rotate-45" />
            </summary>
            <p className="pb-5 pr-8 text-sm leading-relaxed text-zinc-300 sm:text-base" data-testid={`price-faq-answer-${i}`}>{a}</p>
          </details>
        ))}
      </div>
    </section>
  );
};
